import { action, computed, observable } from 'mobx';
import { Family } from '../_interfaces/Family';

export class FamilyManagmentStore {
    @observable private _familyToManage!: Family;
    @observable private _isRemovingMembers = false;

    @computed
    get isRemovingMembers(): boolean {
        return this._isRemovingMembers;
    }
    @computed
    public get familyToManage(): Family {
        return this._familyToManage;
    }

    @action
    public setToRemoveUsers(canRemove: boolean): void {
        this._isRemovingMembers = canRemove;
    }

    @action
    public setFamilyToManage(family: Family): void {
        this._familyToManage = family;
    }
}



// WEBPACK FOOTER //
// ./src/_stores/FamilyManagmentStore.ts